import { render } from "./RecensementFormPage.vue?vue&type=template&id=01fcb03f&ts=true"
import script from "./RecensementFormPage.vue?vue&type=script&lang=ts"
export * from "./RecensementFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__